import { uniq } from "lodash";
import { DimensionData, sizeDisablingUnits } from "./data";
import _ from "lodash";
import { useDataStore } from "store/DataStore";
import  useAdBlockStore  from "store/AdBlockStore";

export const findDuplicates = (products = []) => {
  let arr = uniq(products.map((product) => JSON.stringify(product)));
  if (arr.length === products.length) return false;
  return true;
};

// No real ad block has this many identical entries, even split blocks.
// Counts above this indicate accidental duplication (e.g. a held clone hotkey).
// Keep in sync with MAX_IDENTICAL_ENTRIES in the backend (app/utils/ad.py).
export const MAX_IDENTICAL_SPLIT_ENTRIES = 50;

const productEntryKey = (product = {}) =>
  JSON.stringify({
    ext_brand_i: product.ext_brand_i,
    size_1: product.size_1,
    size_2: product.size_2,
    size_3: product.size_3,
    size_4: product.size_4,
    size_dimension_i: product.size_dimension_i,
    ext_size_unit_i: product.ext_size_unit_i,
    ext_size_unit_2_i: product.ext_size_unit_2_i,
    variant_ids: product.variant_ids,
    origin_ids: product.origin_ids,
    model_number_ids: product.model_number_ids,
    liner_f: product.liner_f,
  });

// Highest number of identical entries (ignoring order_num/index) in the list.
export const maxIdenticalEntries = (productsData = []) => {
  const counts = {};
  productsData.forEach((product) => {
    const key = productEntryKey(product);
    counts[key] = (counts[key] || 0) + 1;
  });
  const values = Object.values(counts);
  return values.length ? Math.max(...values) : 0;
};

export const checkDupeEntry = (productsData) => {
  //check similar product with the same size twice
  let entry_items = [];
  productsData.forEach((product) => {
    let item_obj = {
      ext_brand_i : product.ext_brand_i,
      size_1 : product.size_1,
      size_2 : product.size_2,
      size_3 : product.size_3,
      size_4 : product.size_4,
      size_dimension_i : product.size_dimension_i,
      ext_size_unit_i  : product.ext_size_unit_i,
      ext_size_unit_2_i  : product.ext_size_unit_2_i,
      variant_ids : product.variant_ids,
      origin_ids: product.origin_ids,
      model_number_ids : product.model_number_ids,
      liner_f: product.liner_f
    }
    entry_items.push(item_obj)
  });
  return findDuplicates(entry_items);
}

export const validateProduct = (product = {}, sizeData = []) => {
  
  if (!productSizeValidator({ product })) {
    return;
  }

  if (sizeData.length === 0) {
    const dataStore = useDataStore.getState();
    if (dataStore.isSizesCacheStale()) {
      if (dataStore.productSizes.length === 0) {
        // Block on first fetch(no cached data)
        dataStore.refreshSizes();
      } else {
        // Stale cache—serve old data, refresh in background
        dataStore.backgroundRefreshSizes();
      }
    }
    sizeData = dataStore.productSizes;
  }
  //Validate product on change, check the required fields

  if (!productSizeValidator({ product })) {
    return;
  }
  
  if(!product.ext_size_unit_i)
    return;

  var tempDimensionData = DimensionData;
  let size_name = sizeData.find((size) =>
    size.id === product["ext_size_unit_i"]
  )?.title;
  let size_id = sizeData.find((size) =>
    size.id === product["ext_size_unit_i"]
  )?.id;

  let size_name2 = sizeData.find((size) =>
    size.id === product["ext_size_unit_2_i"]
  )?.title;
  let size_id2 = sizeData.find((size) =>
    size.id === product["ext_size_unit_2_i"]
  )?.id;
  const isDimensionValid = tempDimensionData.find(dimension => dimension.id === product["size_dimension_i"])
  product.isValid = true;
  if (product["size_dimension_i"] === 5 && ((!product["size_1"] || !product["size_3"]) || (!size_name || !size_name2))) {
    return;
  }
  if (product["size_dimension_i"] < 5 || isValidSizes(size_name, size_name2)) {
  if (product["size_dimension_i"] === 26) {
    if (product["size_1"] && product["size_3"] && size_id && size_id2) {
      if (product["size_4"]) {
        return Number(product["size_3"]) < Number(product["size_4"]);
      }
      return true;
    } else {
      return false;
    }
  }
  if (product["ext_brand_i"] === null || product["ext_brand_i"] === '') {
    product.isValid = false;
  } else {
    if (product["size_dimension_i"] !== null && product["size_dimension_i"] !== "" && isDimensionValid) {
      var dimensionSubSet = tempDimensionData.find((x) => x.id === product["size_dimension_i"]).subSets;
      //Turning off size validation, need to find a way to find size undeterminable
      dimensionSubSet.forEach((element) => {
        //skip size_2 if it is size and qty, no validation

        if((element === 'size_1' || element === 'size_2') && 'size undeterminable' === size_name) {
          return;
        }
        
        if((element === 'size_3' || element === 'size_4') && 'size undeterminable' === size_name2) {
          return;
        }
        
        if((element === 'size_1' || element === 'size_2'))
        
        //not sure about this one but if the first can do it why not second set?
        if ((element === "size_2" || element === "size_4") && product["size_dimension_i"] === 5) {
          return;
          
        } else {
          
          if (
            (product[element] === null || product[element] === "") && product.isValid
            ) {
            if(element === 'size_1' && sizeDisablingUnits.includes(size_id) && product["size_dimension_i"] < 6){
              product.isValid = true;
              return
            }
            if(element === 'size_2' && sizeDisablingUnits.includes(size_id) && product["size_dimension_i"] < 6){
              product.isValid = true;
              return
            }
            if(element === 'size_3' && sizeDisablingUnits.includes(size_id2) && product["size_dimension_i"] < 6){
              product.isValid = true;
              return
            }
            if(element === 'size_4' && sizeDisablingUnits.includes(size_id2) && product["size_dimension_i"] < 6){
              product.isValid = true;
              return
            }
            product.isValid = false;
          }
        }
      });
    } else {
      product.isValid = false;
    }
  }
  }
  else {
    product.isValid = false;
  }

  // Validate whole number sizes
  if (product.isValid && size_id) {
    const sizeUnit = sizeData.find(size => size.id === size_id);
    if (sizeUnit?.whole_num_f) {
      const size1 = parseFloat(product.size_1);
      if (isNaN(size1) || !Number.isInteger(size1)) {
        product.isValid = false;
        return product.isValid;
      }
      if (product.size_dimension_i  === 2 || product.size_dimension_i === 4 || product.size_dimension_i === 6 || product.size_dimension_i === 7 || product.size_dimension_i === 9 || product.size_dimension_i === 26) {
        const size2 = parseFloat(product.size_2);
        if (isNaN(size2) || !Number.isInteger(size2)) {
          product.isValid = false;
          return product.isValid;
        }
      }
    }
  }
  if (product.isValid && size_id2) {
    const sizeUnit2 = sizeData.find(size => size.id === size_id2);
    if (sizeUnit2?.whole_num_f) {

      if (product.size_dimension_i === 7) {
        const size2 = parseFloat(product.size_2);
        if (isNaN(size2) || !Number.isInteger(size2)) {
          product.isValid = false;
          return product.isValid;
        }
      }

      if (product.size_dimension_i === 5) {
        const size2 = parseFloat(product.size_2);
        const size3 = parseFloat(product.size_3);
        const size4 = parseFloat(product.size_4);
        // Allow empty size_2 and size_3
        if ((product.size_2 && (isNaN(size2) || !Number.isInteger(size2))) ||
            (product.size_3 && (isNaN(size3) || !Number.isInteger(size3))) ||
            (product.size_4 && (isNaN(size4) || !Number.isInteger(size4)))) {
              console.log(size2, size3, size4);
          product.isValid = false;
          return product.isValid;
        }
      }
      
      if (product.size_dimension_i === 6 || product.size_dimension_i === 9 || product.size_dimension_i === 26) {
        const size3 = parseFloat(product.size_3);
        if (isNaN(size3) || !Number.isInteger(size3)) {
          product.isValid = false;
          return product.isValid;
        }
      }
      if (product.size_dimension_i === 9 || product.size_dimension_i === 26) {
        const size4 = parseFloat(product.size_4);
        if (isNaN(size4) || !Number.isInteger(size4)) {
          product.isValid = false;
          return product.isValid;
        }
      }
      if (product.size_dimension_i === 6 || product.size_dimension_i === 7) {
        const size2 = parseFloat(product.size_2);
        if (isNaN(size2) || !Number.isInteger(size2)) {
          product.isValid = false;
          return product.isValid;
        }
      }
    }
  }
  
  return product.isValid;
}

export const isValidSizes = (size1, size2) => {
  const size_group = new Set([
    "ct./pk.",
    "ct./pk. bottles",
    "ct./pk. cans",
    "ct./pk. cans/bottles"
  ]);
  if (size1 != size2) {
    return !(size_group.has(size1) && size_group.has(size2));
  }
  else {
    return true;
  }
}

export const unitSizeRestrictionMessage = (productsData = []) => {
  const unitResMessage = {}
  productsData.forEach((product) => {
    const selectedSize = product.sizes?.find(size => size.id === product.ext_size_unit_i);
    const selectedSize2 = product.sizes?.find(size => size.id === product.ext_size_unit_2_i);
    const size_1 = parseFloat(product.size_1);
    const size_2 = parseFloat(product.size_2);
    const size_3 = parseFloat(product.size_3);
    const size_4 = parseFloat(product.size_4);
    const current_product = product.brand_nm
    const max = selectedSize?.max;
    const min = selectedSize?.min;
    if (max === 0 && min === 0) {
      return;
    }
    const max2 = selectedSize2?.max;
    const min2 = selectedSize2?.min;
    if (product.size_dimension_i === 2) {
      if (size_1 > max || size_1 < min || size_2 > max || size_2 < min) {
        unitResMessage[current_product] = {dimension: product.size_dimension_i, size_1, size_2, max, min}
      }
    }
    if (product.size_dimension_i === 5) {
      if (size_1 > max || size_1 < min || size_2 > max || size_2 < min) {
        unitResMessage[current_product] = {dimension: product.size_dimension_i, size_1, size_2, max, min}
      }
      if (size_3 > max2 || size_3 < min2 || size_4 > max2 || size_4 < min2) {
        if (!unitResMessage.hasOwnProperty(current_product)) unitResMessage[current_product] = {}; 
        unitResMessage[current_product].dimension = product.size_dimension_i
        unitResMessage[current_product].size_1 = size_1
        unitResMessage[current_product].size_2 = size_2
        unitResMessage[current_product].size_3 = size_3
        unitResMessage[current_product].size_4 = size_4
        unitResMessage[current_product].max2 = max2
        unitResMessage[current_product].min2 = min2
        unitResMessage[current_product].min = min
        unitResMessage[current_product].max = max
      }
    }
    if (product.size_dimension_i === 6) {
      if (size_1 > max || size_1 < min || size_2 > max2 || size_2 < min2) {
        unitResMessage[current_product] = {dimension: product.size_dimension_i, size_1, size_2, max, min, max2, min2}
      }
    }
    if (product.size_dimension_i !== 2 && product.size_dimension_i !== 5 && product.size_dimension_i !== 6) {
      if (size_1 > max || size_1 < min) {
        unitResMessage[current_product] = {dimension: product.size_dimension_i, size_1, max, min}
      }
    }
  })
  return unitResMessage;
}

export const sizeValueBuilder = (
  sizeData,
  size_1,
  size_2,
  size_3,
  size_4,
  ext_size_unit_i,
  ext_size_unit_2_i,
  size_dimension_i
) => {
  if (size_dimension_i === 2) {
    return `${size_1} - ${size_2} ${sizeData.find((size) => size.id === ext_size_unit_i)?.title}`;
  }
  else if (size_dimension_i === 4) {
    return `${size_1} x ${size_2} ${sizeData.find((size) => size.id === ext_size_unit_i)?.title} `
  }
  else if (size_dimension_i === 5) {
    return `${size_1} ${size_2} ${sizeData.find((size) => size.id === ext_size_unit_i)?.title} of ${size_3}-${size_4} ${sizeData.find((size) => size.id === ext_size_unit_2_i)?.title}`
  }
  else if (size_dimension_i === 6) {
    return `${size_1} ${sizeData.find((size) => size.id === ext_size_unit_i )?.title} ${size_2} ${sizeData.find((size) => size.id === ext_size_unit_2_i)?.title}`
  }
  else if (size_dimension_i === 7) {
    return `${size_1} ${sizeData.find((size) => size.id === ext_size_unit_i)?.title} ${size_2} ${sizeData.find((size) => size.id === ext_size_unit_2_i)?.title}`
  }
  else if (size_dimension_i === 9) {
    return `${size_1}x${size_2} ${sizeData.find((size) => size.id === ext_size_unit_i)?.title} ${size_3}x${size_4} ${sizeData.find((size) => size.id === ext_size_unit_2_i)?.title}`
  }
  else {
    return `${size_1} ${sizeData.find((size) => size.id === ext_size_unit_i)?.title}`
  }
}

export const getUniqueProducts = (productsTemp) => {
  let productsUnique = [];
  productsTemp.forEach((product) => {
    if (!productsUnique.some(e => e.brand_nm === product.brand_nm) || !productsUnique.some(e => e.brand?.brand_nm === product.brand?.brand_nm)) {
      productsUnique.push(product);
    }
  })
  return productsUnique;
}

export const productStringEval = (product = {}, sizeData = [], index = 0, showIndex = true) => {
  const brand = product.brand_nm || product.brand?.brand_name
  const idxBrand = showIndex ? `${index + 1}. ${brand}` : brand
  const getVariantName = (product) => {
    if (product?.variant_nms) return product.variant_nms.join(', ');
    if (_.isObject(product?.variants)) return product.variants?.map(v => v.variety_nm)?.join(', ');
    return '';
  };

  const getOriginName = (product) => {
    if (product?.origin_nms) return product.origin_nms.join(', ');
    if (_.isObject(product?.origins)) return product.origins?.map(o => o.origin_nm)?.join(', ');
    return '';
  };

  const getSizeUnit = (sizeId) => {
    const size = sizeData.find((size) => size.id === sizeId)
      || product.sizes?.find((size) => size.id === sizeId);
    return size ? size.title : '';
  };

  const renderSizeString = () => {
    switch (product.size_dimension_i) {
      case 2: // Range
        return `${product.size_1 || ''}${product.size_2 ? `-${product.size_2 ||  ''}` : ''} ${getSizeUnit(product.ext_size_unit_i)}`;
      case 3: // Plus
        return `${product.size_1 || ''}+ ${getSizeUnit(product.ext_size_unit_i)}`;
      case 4: // Multi
        return `${product.size_1 || ''} x ${product.size_2} ${getSizeUnit(product.ext_size_unit_i)}`;
      case 5: // Size Qty
        return `${product.size_1 || ''}${product.size_2 ? ` -${product.size_2}` : ''} ${getSizeUnit(product.ext_size_unit_i)} ${product.size_3 ? `of ${product.size_3}` : ''}${product.size_4 ? `-${product.size_4}` : ''} ${getSizeUnit(product.ext_size_unit_2_i)}`;
      case 6: // RangeDoubleSize
        return `${product.size_1 || ''} ${getSizeUnit(product.ext_size_unit_i)}${product.size_2 || '' ? ` - ${product.size_2 || ''} ${getSizeUnit(product.ext_size_unit_2_i)}` : ''}`;
      case 7: // Double
        return `${product.size_1 || ''} ${getSizeUnit(product.ext_size_unit_i)} ${product.size_2 || ''} ${getSizeUnit(product.ext_size_unit_2_i)}`;
      case 9: // AreaRange
        return `${product.size_1 || ''}x${product.size_2 || ''} ${getSizeUnit(product.ext_size_unit_i)} ${product.size_3 || ''}x${product.size_4 || ''} ${getSizeUnit(product.ext_size_unit_2_i)}`;
      case 26: // TotalSize
        return `${product.size_1 || ''} ${getSizeUnit(product.ext_size_unit_i)}${product.size_3 || '' ? ` of ${product.size_3 || ''}` : ''}${product.size_4 || '' ? ` - ${product.size_4 || ''}` : ''} ${getSizeUnit(product.ext_size_unit_2_i)}`;
      default: // Single
        return `${product.size_1 || ''} ${getSizeUnit(product.ext_size_unit_i)}`;
    }
  };

  const productString = brand ? (
    <div className="flex-1">
      {idxBrand} {getVariantName(product)} {getOriginName(product)} {renderSizeString()} {product.liner_f ? " - Liner" : ''}
    </div>
  ) : (
    <div className="flex-1">{`Unbranded Product ${index + 1}`}</div>
  );
  return productString
}

export const getSizeType = (unit, sizeData) => sizeData?.find(item => item.id === unit.value)?.whole_num_f ? 'int' : 'float';

const sanitizeMovFields = (product = {}, brands = []) => {
  const brandFromList = product?.ext_brand_i !== null && product?.ext_brand_i !== undefined
    ? brands.find((brand) => brand.ext_id === product.ext_brand_i)
    : null;
  const brandVariants = Array.isArray(product?.brand?.variants)
    ? product.brand.variants
    : Array.isArray(brandFromList?.variants)
      ? brandFromList.variants
      : [];
  const brandOrigins = Array.isArray(product?.brand?.origins)
    ? product.brand.origins
    : Array.isArray(brandFromList?.origins)
      ? brandFromList.origins
      : [];
  const brandModelNumbers = Array.isArray(product?.brand?.model_numbers)
    ? product.brand.model_numbers
    : Array.isArray(brandFromList?.model_numbers)
      ? brandFromList.model_numbers
      : [];

  const variantIds = Array.isArray(product?.variant_ids)
    ? product.variant_ids
    : product?.variant_ids !== undefined && product?.variant_ids !== null && product?.variant_ids !== ''
      ? [product.variant_ids]
      : [];
  const originIds = Array.isArray(product?.origin_ids)
    ? product.origin_ids
    : product?.origin_ids !== undefined && product?.origin_ids !== null && product?.origin_ids !== ''
      ? [product.origin_ids]
      : [];
  const modelNumberIds = Array.isArray(product?.model_number_ids)
    ? product.model_number_ids
    : product?.model_number_ids !== undefined && product?.model_number_ids !== null && product?.model_number_ids !== ''
      ? [product.model_number_ids]
      : [];

  const variantIdSet = new Set(brandVariants.map((item) => String(item?.ext_id ?? item?.id)));
  const originIdSet = new Set(brandOrigins.map((item) => String(item?.ext_id ?? item?.id)));
  const modelNumberIdSet = new Set(brandModelNumbers.map((item) => String(item?.ext_id ?? item?.id)));

  const filteredVariantIds = brandVariants.length > 0
    ? variantIds.filter((id) => variantIdSet.has(String(id)))
    : [];
  const filteredOriginIds = brandOrigins.length > 0
    ? originIds.filter((id) => originIdSet.has(String(id)))
    : [];
  const filteredModelNumberIds = brandModelNumbers.length > 0
    ? modelNumberIds.filter((id) => modelNumberIdSet.has(String(id)))
    : [];

  const filteredVariants = Array.isArray(product?.variants)
    ? product.variants.filter((item) => variantIdSet.has(String(item?.ext_id ?? item?.id)))
    : [];
  const filteredOrigins = Array.isArray(product?.origins)
    ? product.origins.filter((item) => originIdSet.has(String(item?.ext_id ?? item?.id)))
    : [];
  const filteredModelNumbers = Array.isArray(product?.model_numbers)
    ? product.model_numbers.filter((item) => modelNumberIdSet.has(String(item?.ext_id ?? item?.id)))
    : [];

  return {
    ...product,
    variant_ids: filteredVariantIds,
    variants: filteredVariants.length > 0 ? filteredVariants : null,
    variant_nms: filteredVariantIds.length > 0 ? product?.variant_nms || [] : [],
    origin_ids: filteredOriginIds,
    origins: filteredOrigins.length > 0 ? filteredOrigins : null,
    origin_nms: filteredOriginIds.length > 0 ? product?.origin_nms || [] : [],
    model_number_ids: filteredModelNumberIds,
    model_numbers: filteredModelNumbers.length > 0 ? filteredModelNumbers : null,
    model_number_nms: filteredModelNumberIds.length > 0 ? product?.model_number_nms || [] : [],
  };
};

export const parseProduct = ({productData = [], sizeData = [], isExisting = false, unique = false, brands = [], open_ai = false,isSuggestion = false, addison_agent = false}) => {
  if (sizeData.length === 0) {
    const dataStore = useDataStore.getState();
    if (dataStore.isSizesCacheStale()) {
      if (dataStore.productSizes.length === 0) {
        // Block on first fetch(no cached data)
        dataStore.refreshSizes();
      } else {
        // Stale cache—serve old data, refresh in background
        dataStore.backgroundRefreshSizes();
      }
    }
  }
  const parsedProducts = productData.map((product, index) => ({
    ...product,
    id: product?.uuid,
    ext_brand_i: product?.ext_brand_i ? product.ext_brand_i : product?.ext_id ? product?.ext_id : null,
    size_1: product.size_1 && sizeDisablingUnits.includes(product.ext_size_unit_i) ? null : product.size_1,
    size_2: product.size_dimension_i > 1 ? product.size_2 : null,
    size_3: product.size_dimension_i > 2 ? product.size_3 : null,
    size_4: product.size_dimension_i > 2 ? product.size_4 : null,
    size_dimension_i: product?.size_dimension_i ? product.size_dimension_i : 1, // Default to 'Single' if not provided
    ext_size_unit_i: product?.ext_size_unit_i ? product.ext_size_unit_i : 87, // Default to 'size undeterminable' if not provided
    brand_nm: product.brand?.brand_name ? product.brand?.brand_name : product.brand_nm ? product.brand_nm : '',
    index,
    variant_ids: product?.variant_ids ? product?.variant_ids : product.brand?.variants ? product.brand?.variant_ids : product.ext_brand_i !== null
      ? brands.find(
        (brand) => brand.ext_id === product.ext_brand_i
      )?.variants.length > 0
        ? brands
          .find((brand) => brand.ext_id === product.ext_brand_i)
          ?.variants.find((variant) => variant.id === product.variant_ids) ?
          product.variant_ids
          : []
        : []
      : [],
    variantsData: product.brand?.variants
      ? product.brand?.variants.map((item) => ({
        id: item.ext_id,
        title: item.variety_nm,
      }))
      : product.ext_brand_i !== null
        ? brands.find(
          (brand) => brand.ext_id === product.ext_brand_i
        )?.variants.length > 0
          ? brands
            .find((brand) => brand.ext_id === product.ext_brand_i)
            ?.variants.map((item) => ({
              id: item.ext_id,
              title: item.variety_nm,
            }))
          : []
        : [],
    origin_ids: product?.origin_ids ? product?.origin_ids : product.brand?.origins ? product.brand?.origin_ids : product.ext_brand_i !== null
      ? brands.find(
        (brand) => brand.ext_id === product.ext_brand_i
      )?.origins.length > 0
        ? brands
          .find((brand) => brand.ext_id === product.ext_brand_i)
          .origins.find((origin) => origin.id === product.origin_ids) ?
          product.origin_ids
          : []
        : []
      : [],
    originsData: product.brand?.origins
      ? product.brand?.origins.map((item) => ({
        id: item.ext_id,
        title: item.origin_nm,
      }))
      : product.ext_brand_i !== null
        ? brands.find(
          (brand) => brand.ext_id === product.ext_brand_i
        )?.origins.length > 0
          ? brands
            .find((brand) => brand.ext_id === product.ext_brand_i)
            .origins?.map((item) => ({
              id: item.ext_id,
              title: item.origin_nm,
            }))
          : []
        : [],
    model_number_ids: product?.model_number_ids ? product?.model_number_ids : product.brand?.model_numbers ? product.model_number_ids : product.ext_brand_i !== null
      ? brands.find(
        (brand) => brand.ext_id === product.ext_brand_i
      )?.model_numbers?.length > 0
        ? brands
          .find((brand) => brand.ext_id === product.ext_brand_i)
          .model_numbers.find((model_number) => model_number.id === product.model_number_ids) ?
          product.model_number_ids
          : []
        : []
      : [],
    modelNumbersData: product.brand?.model_numbers
      ? product.brand?.model_numbers.map((item) => ({
        id: item.ext_id,
        title: item.model_number
      }))
      : product.ext_brand_i !== null
        ? brands.find(
          (brand) => brand.ext_id === product.ext_brand_i
        )?.model_numbers?.length > 0
          ? brands
            .find((brand) => brand.ext_id === product.ext_brand_i)
            ?.model_numbers?.map((item) => ({
              id: item.ext_id,
              title: item.model_number,
            }))
          : []
        : [],
    // For suggestions only: START
    variant_nms: product.variants ? product.variants.map(v => v.variety_nm) : (() => {
      const brand = brands.find((brand) => brand.ext_id === product.ext_brand_i);
      if (brand?.variants?.length && product.variant_ids) {
        return brand.variants
          .filter((variant) => product.variant_ids.includes(variant.ext_id))
          .map((variant) => variant.variety_nm) || [];
      }
      return [];
    })(),
    origin_nms: product.origins ? product.origins.map(o => o.origin_nm) : (() => {
      const brand = brands.find((brand) => brand.ext_id === product.ext_brand_i);
      if (brand?.origins?.length && product.origin_ids) {
        return brand.origins
          .filter((origin) => product.origin_ids.includes(origin.ext_id))
          .map((origin) => origin.origin_nm) || [];
      }
      return [];
    })(),
    model_number_nms: product.model_numbers ? product.model_numbers.map(m => m.model_number) : (() => {
      const brand = brands.find((brand) => brand.ext_id === product.ext_brand_i);
      if (brand?.model_numbers?.length && product.model_number_ids) {
        return brand.model_numbers
          .filter((model_number) => product.model_number_ids.includes(model_number.ext_id))
          .map((model_number) => model_number.model_number) || [];
      }
      return [];
    })(),
    // For suggestions only: END
    sizes: product.brand?.sizes ? product.brand.sizes.map((item) => ({
      id: item.ext_id,
      title: item.size_c,
      max: item.max,
      min: item.min
    })) : product.ext_brand_i !== null
      ? brands.find(
        (brand) => brand.ext_id === product.ext_brand_i
      )?.sizes?.length > 0
        ? brands
          .find((brand) => brand.ext_id === product.ext_brand_i)
          .sizes?.map((item) => ({
            id: item.ext_id,
            title: item.size_c
          }))
        : []
      : [],
    is_adult_bev: product.brand?.is_adult_bev,
    sub_cat_i: product.brand?.sub_cat_i ? product.brand?.sub_cat_i : brands.length > 0 ? brands.find(brand => brand.brand_id === product.brand_id)?.sub_cat_i : null,
    existingProduct: isExisting,
    open_ai: open_ai,
    addison_agent: addison_agent,
    isSuggestion: isSuggestion
  }));
  const sanitizedProducts = parsedProducts.map((product) => sanitizeMovFields(product, brands));
  const validatedProducts = sanitizedProducts.map((product) => ({
    ...product,
    isValid: validateProduct(product, sizeData)
  }));
  // Return unique products if unique flag is true, otherwise return all products
  return unique ? getUniqueProducts(validatedProducts) : validatedProducts;
};


export const disableSize = ({ product, index }) => {
  // Replicates the logic from index.js lines 1233-1257
  if (product['size_dimension_i'] === 1 || product['size_dimension_i'] === 3) {
    product['size_1'] = product['size_1'] ? product['size_1'] : null;
    product['size_2'] = null;
    product['size_3'] = null;
    product['size_4'] = null;
  } else if (product['size_dimension_i'] === 2 || product['size_dimension_i'] === 4 || product['size_dimension_i'] === 6 || product['size_dimension_i'] === 7) {
    product['size_1'] = product['size_1'] ? product['size_1'] : null;
    product['size_2'] = product['size_2'] ? product['size_2'] : null;
    product['size_3'] = null;
    product['size_4'] = null;
  } else if (product['size_dimension_i'] === 5 || product['size_dimension_i'] === 9) {
    product['size_1'] = product['size_1'] ? product['size_1'] : null;
    product['size_2'] = product['size_2'] ? product['size_2'] : null;
    product['size_3'] = product['size_3'] ? product['size_3'] : null;
    product['size_4'] = product['size_4'] ? product['size_4'] : null;
  } else if (product['size_dimension_i'] === 26) {
    product['size_1'] = product['size_1'] ? product['size_1'] : null;
    product['size_2'] = null;
    product['size_3'] = product['size_3'] ? product['size_3'] : null;
    product['size_4'] = product['size_4'] ? product['size_4'] : null;
  }

  product['ext_size_unit_2_i'] = ([5, 6, 7, 9, 26].includes(product['size_dimension_i']) && product['ext_size_unit_2_i']) ? product['ext_size_unit_2_i'] : null;

  product['order_num'] = index;
  if (sizeDisablingUnits.includes(product['ext_size_unit_i'])){
    product['size_1'] = null;
    product['size_2'] = null;
  }
  if (sizeDisablingUnits.includes(product['ext_size_unit_2_i'])) {
    product['size_3'] = null;
    product['size_4'] = null;
  }
  return product;
}

export const productSizeValidator = ({ product }) => {
  const dimension = product?.size_dimension_i;
  switch (dimension) {
    case 2:
      return Number(product.size_1) < Number(product.size_2);
    case 5:
    case 9:
      return (
        (product.size_2 !== undefined && product.size_2 !== null && product.size_2 !== '' ? Number(product.size_1) < Number(product.size_2) : true) &&
        (product.size_4 !== undefined && product.size_4 !== null && product.size_4 !== '' ? Number(product.size_3) < Number(product.size_4) : true)
      );
    default:
      return true;
  }
}

export const checkTeaSizeViolation = (products = [], productSizes = []) => {
  const TEA_BRANDS = ['lipton pure leaf', 'gold peak', 'tazo'];
  const TEA_SUB_CAT_I = '250338'; //Ready To Drink Tea

  return products.some((product) => {
    const brandNm = (product?.brand?.brand_group_name || '').toLowerCase();
    const isBrandMatch = TEA_BRANDS.some((brand) => brandNm.includes(brand));
    if (!isBrandMatch) return false;
    if (product?.brand?.sub_cat_i != TEA_SUB_CAT_I) return false;
    const sizeUnit = productSizes.find((s) => s.id === product.ext_size_unit_i);
    const isOzUnit = sizeUnit ? sizeUnit.title.toLowerCase().includes('oz') : false;
    const isLargeSize = product.size_dimension_i == 1 ? parseFloat(product.size_1) > 20 : false;
    return isOzUnit && isLargeSize;
  });
};

export const parseAgentSuggestionBrands = (brands = [], sizeData = []) =>
  parseProduct({
    productData: brands.map((brand) => ({
      ext_brand_i: brand.ext_id,
      brand_nm: brand.brand_name,
      brand,
    })),
    sizeData,
    isSuggestion: true,
    addison_agent: true,
  });
